import * as React from "react";
import type { SVGProps } from "react";

const SvgEnvelopeCheckIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="51"
        height="53.807"
        viewBox="0 0 51 53.807"
        {...props}
    >
        <g
            id="Group_10427"
            data-name="Group 10427"
            transform="translate(-574 -754.935)"
        >
            <g
                id="Bank_Commerce_Icon_12_Blue"
                data-name="Bank&amp;Commerce Icon 12 Blue"
                transform="translate(574 754.935)"
            >
                <path
                    id="Path_1442"
                    data-name="Path 1442"
                    d="M66.13,28.45l-6.306-4.584V9.469A1.471,1.471,0,0,0,58.354,8H24.477a1.471,1.471,0,0,0-1.469,1.469v14.4L16.7,28.45a1.828,1.828,0,0,0-.742,1.917,1.3,1.3,0,0,0-.032.289V60.511a1.1,1.1,0,0,0,.025.168.394.394,0,0,0,.028.106c.011.035,0,.025.012.039s.014.057.025.083a1.416,1.416,0,0,0,1.326.9H65.487a1.416,1.416,0,0,0,1.319-.9c.011-.026.016-.056.025-.083s.009-.027.012-.039.021-.071.028-.106a1.1,1.1,0,0,0,.025-.168V30.656a1.3,1.3,0,0,0-.032-.289A1.828,1.828,0,0,0,66.13,28.45ZM24.424,30.656V9.469a.055.055,0,0,1,.053-.053H58.354a.055.055,0,0,1,.053.053v25.45l-10.62,7.1-1.211.809-5.113,3.407-.014.009a.058.058,0,0,1-.067,0l-.014-.009-5.1-3.409-1.211-.809L24.424,34.919Zm-7.094-.7a.4.4,0,0,1,.177-.338l.034-.025.49-.354,4.977-3.625v8.358l-4.972-3.319L17.5,30.3A.4.4,0,0,1,17.33,29.958Zm.014,1.936L33.982,43,17.344,58.457Zm48.06,28.5H17.427a.129.129,0,0,1-.067-.016L35.2,43.814l5.386,3.6a1.474,1.474,0,0,0,1.667,0l5.386-3.6L65.471,60.375A.129.129,0,0,1,65.4,60.391Zm.083-1.933L48.85,43.006,65.487,31.895ZM65.335,30.3l-.54.354-4.972,3.319V25.617l4.984,3.623.49.354.034.025a.423.423,0,0,1,0,.674Z"
                    transform="translate(-15.913 -8)"
                />
                <ellipse
                    id="Ellipse_400"
                    data-name="Ellipse 400"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(11.255 44.808)"
                />
                <ellipse
                    id="Ellipse_401"
                    data-name="Ellipse 401"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(10.819 48.407)"
                />
                <ellipse
                    id="Ellipse_402"
                    data-name="Ellipse 402"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(14.065 48.407)"
                />
                <ellipse
                    id="Ellipse_403"
                    data-name="Ellipse 403"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(16.875 44.808)"
                />
                <ellipse
                    id="Ellipse_404"
                    data-name="Ellipse 404"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(22.496 44.808)"
                />
                <ellipse
                    id="Ellipse_405"
                    data-name="Ellipse 405"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(19.686 48.407)"
                />
                <ellipse
                    id="Ellipse_406"
                    data-name="Ellipse 406"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(25.306 48.407)"
                />
                <ellipse
                    id="Ellipse_407"
                    data-name="Ellipse 407"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(28.116 44.808)"
                />
                <ellipse
                    id="Ellipse_408"
                    data-name="Ellipse 408"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(33.736 44.808)"
                />
                <ellipse
                    id="Ellipse_409"
                    data-name="Ellipse 409"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(30.926 48.407)"
                />
                <ellipse
                    id="Ellipse_410"
                    data-name="Ellipse 410"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(36.546 48.407)"
                />
                <ellipse
                    id="Ellipse_411"
                    data-name="Ellipse 411"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(39.356 44.808)"
                />
                <ellipse
                    id="Ellipse_412"
                    data-name="Ellipse 412"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(40.189 48.407)"
                />
                <ellipse
                    id="Ellipse_413"
                    data-name="Ellipse 413"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(14.065 41.208)"
                />
                <ellipse
                    id="Ellipse_414"
                    data-name="Ellipse 414"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(19.686 41.208)"
                />
                <ellipse
                    id="Ellipse_415"
                    data-name="Ellipse 415"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(25.306 41.208)"
                />
                <ellipse
                    id="Ellipse_416"
                    data-name="Ellipse 416"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(30.926 41.208)"
                />
                <ellipse
                    id="Ellipse_417"
                    data-name="Ellipse 417"
                    cx="0.9"
                    cy="0.9"
                    rx="0.9"
                    ry="0.9"
                    transform="translate(36.546 41.208)"
                />
            </g>
            <g
                id="checkmark-spot-filled"
                transform="translate(586.756 764.263)"
            >
                <path
                    id="Icon"
                    d="M16.521,4A12.521,12.521,0,1,1,4,16.521,12.521,12.521,0,0,1,16.521,4Zm4.322,6.767L15.27,20.055l-3.229-3.229A1.043,1.043,0,0,0,10.566,18.3l5.118,5.118,6.948-11.58a1.043,1.043,0,1,0-1.789-1.074Z"
                    transform="translate(-4 -4)"
                    fill="#0076d6"
                />
            </g>
        </g>
    </svg>
);
export default SvgEnvelopeCheckIcon;
